import axios from "axios";
import authStore from "../../stores/AuthStore";

abstract class BaseService {
  baseUrl: string = process.env.REACT_APP_API || "";

  private getHeaders(): Record<string, string> {
    return {
      Authorization: `Bearer ${authStore.token}`,
      "Content-Type": "application/json",
      Language: localStorage.getItem("preferredLanguage")?.toString() || "tr",
    };
  }

  async fetch<R>(
    uri: string,
    params?: { [key: string]: string | undefined }
  ): Promise<R> {
    const url = uri.includes("http") ? uri : `${this.baseUrl}/${uri}`;
    return (
      await axios.get<R>(`${url}`, {
        params,
        headers: this.getHeaders(),
      })
    ).data;
  }

  async post<R, P>(uri: string, payload?: P): Promise<R> {
    return (
      await axios.post<R>(`${this.baseUrl}/${uri}`, payload, {
        headers: this.getHeaders(),
      })
    ).data;
  }

  async put<R, P>(uri: string, payload?: P): Promise<R> {
    return (
      await axios.put<R>(`${this.baseUrl}/${uri}`, payload, {
        headers: this.getHeaders(),
      })
    ).data;
  }

  async delete<R>(uri: string, params?: Record<string, string>[]): Promise<R> {
    return (
      await axios.delete<R>(`${this.baseUrl}/${uri}`, {
        params,
        headers: this.getHeaders(),
      })
    ).data;
  }
}

export default BaseService;
